import { ProductSelection } from "flow/api/types";
import config from "flow/config";
import MyFlow from "flow/MyFlow";
import sessionStorage from "flow/wrappers/sessionStorage";

export function getProductSelectionFromSessionStorage(myFlow: MyFlow): ProductSelection {
    const selectionJSON = sessionStorage.getItem(config.storageKeys.selectedProduct);
    if (selectionJSON) {
        try {
            const productSelection = JSON.parse(selectionJSON);
            productSelection.remember = false;
            return productSelection;
        } catch (e) {
            myFlow.warn(
                "Found selected product in session storage, but selection was not parsable. Will ask user to select.",
                e
            );
        }
    }
    return undefined;
}

export function saveProductSelectionToSessionStorage(selection: ProductSelection) {
    if (selection.external) {
        throw new Error("Never save external products to session storage");
    }

    // We only store the selectable things
    // The rest we get fresh from validation/sanitizing call each time.
    const sessionStorageObject: ProductSelection = {
        id: selection.id,
        payload: selection.payload,
        external: selection.external
    };

    // Save selection in session storage
    sessionStorage.setItem(config.storageKeys.selectedProduct, JSON.stringify(sessionStorageObject));
}

export function hasLastProductStoredInSessionStorage() {
    return sessionStorage.getItem(config.storageKeys.lastProduct) !== null;
}
